import { ReactNode } from 'react'
import { useChainId } from 'wagmi'

import { TxTypes } from 'constants/transaction'
import { getEtherscanLink } from 'utils/crypto'
import { Icon, Loader } from 'components/ui'

import { WrapContentApprove, Text, Wrapper, StyledLink, InfoTextSmall } from './Style'

type Props = {
  txHash: string
  isSent: boolean
  txType: TxTypes
  children?: ReactNode
  errorMessage: string
}

export function Approve({ txHash, children, txType, isSent, errorMessage }: Props) {
  const chainId = useChainId()

  return (
    <>
      {!errorMessage && !txHash && (
        <WrapContentApprove>
          <Wrapper>
            <Loader size={7.2} />
          </Wrapper>
          <Text>Please, sign {txType} transaction in&nbsp;your wallet</Text>
          {children}
        </WrapContentApprove>
      )}

      {!isSent && txHash && !errorMessage && (
        <WrapContentApprove>
          <Wrapper>
            <Loader size={7.2} />
          </Wrapper>
          <Text>Your transaction is&nbsp;being processed, please wait</Text>
          <InfoTextSmall>
            If&nbsp;you close this window, you can continue to&nbsp;execute the airdrop after transaction mining
          </InfoTextSmall>
        </WrapContentApprove>
      )}

      {isSent && txHash && (
        <WrapContentApprove>
          <Wrapper>
            <Icon name='sentTx' size='xxl' />
          </Wrapper>
          <Text>{txType} of&nbsp;the transaction has been sent</Text>
          <StyledLink href={`${getEtherscanLink(chainId, txHash, 'transaction')}`}>
            Explore Tx <Icon name='externalLink' size='extraMedium' />
          </StyledLink>
        </WrapContentApprove>
      )}

      {errorMessage && (
        <WrapContentApprove>
          <Wrapper>
            <Icon name='errorTx' size='xxl' />
          </Wrapper>
          <Text type='error'>{errorMessage}</Text>
        </WrapContentApprove>
      )}
    </>
  )
}
